var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrowTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 32,
    viewBox: "0 0 16 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.18782 15.9328L15.2552 5.18095C15.7322 4.61188 16 3.84208 16 3.03968C16 2.23728 15.7322 1.46748 15.2552 0.898416C15.017 0.613739 14.7338 0.387783 14.4216 0.233585C14.1095 0.0793879 13.7747 0 13.4366 0C13.0984 0 12.7636 0.0793879 12.4515 0.233585C12.1394 0.387783 11.8561 0.613739 11.618 0.898416L0.757657 13.7764C0.517581 14.0587 0.327029 14.3947 0.19699 14.7648C0.066951 15.1349 0 15.5319 0 15.9328C0 16.3338 0.066951 16.7308 0.19699 17.1009C0.327029 17.471 0.517581 17.8069 0.757657 18.0893L11.618 31.1191C11.8573 31.4006 12.1412 31.6233 12.4532 31.7745C12.7653 31.9256 13.0995 32.0023 13.4366 31.9999C13.7737 32.0023 14.1078 31.9256 14.4199 31.7745C14.732 31.6233 15.0158 31.4006 15.2552 31.1191C15.7322 30.5501 16 29.7803 16 28.9779C16 28.1755 15.7322 27.4057 15.2552 26.8366L6.18782 15.9328Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowTransparent);
export default __webpack_public_path__ + "static/media/left-arrow-transparent.64d643f41b71232ce43a3769eda3b652.svg";
export { ForwardRef as ReactComponent };